-- | Waits for browser events from static/modules/step3-form.js.
-- | The JavaScript listener completes this Aff after the first request, but it
-- | stays active until the next browser turn so same-turn request bursts still
-- | receive the current document before App.Runtime re-subscribes.
module App.Step3DocumentRequest
    ( awaitRequest
    ) where

import Common

import Effect.Aff.Compat (EffectFnAff, fromEffectFnAff)

awaitRequest :: String -> Aff Unit
awaitRequest doc =
    fromEffectFnAff $ awaitRequestImpl doc

foreign import awaitRequestImpl :: String -> EffectFnAff Unit
